import type { PlaceCategoryDto } from '@upme/contracts';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@upme/ui/components/alert-dialog';
import { Button } from '@upme/ui/components/button';
import { Input } from '@upme/ui/components/input';
import { useState } from 'react';
import { toast } from 'sonner';
import { useDeletePlaceCategory } from '../api/place-categories.queries';

interface Props {
  category: PlaceCategoryDto;
  onDeleted: () => void;
}

export function DeletePlaceCategoryDialog({ category, onDeleted }: Props) {
  const [confirm, setConfirm] = useState('');
  const del = useDeletePlaceCategory();

  const canConfirm = confirm === category.slug;

  const handleConfirm = async () => {
    try {
      await del.mutateAsync(category.id);
      toast.success('Категория удалена');
      onDeleted();
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Не удалось удалить';
      toast.error(message);
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="destructive">Удалить</Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Удалить категорию «{category.name}»?</AlertDialogTitle>
          <AlertDialogDescription>
            Сервер откажет в удалении, если категория используется хотя бы в одном месте. Чтобы скрыть
            категорию без удаления — выключите переключатель «Активна».
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="my-4">
          <p className="text-sm mb-2">
            Для подтверждения введите <code className="bg-muted px-1 rounded">{category.slug}</code>:
          </p>
          <Input placeholder="Введите slug" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>Отмена</AlertDialogCancel>
          <AlertDialogAction disabled={!canConfirm} onClick={handleConfirm}>
            Удалить
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
